var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pay-qa-box"},[_c('div',{staticClass:"qa-box pointer",on:{"click":_vm.handleGotoQa}},[_vm._v(" 문의하기 ")]),(_vm.chkMain)?_c('div',{staticClass:"pay-box pointer",on:{"click":function($event){return _vm.clickMore('https://carrotenglish.kr/phone/register_payment_global')}}},[_vm._v(" 결제하기 ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }